const routes = {
  home: '/',
  tableexcel: '/image_table',
  tableexcels: '/excels',
  photo: '/photo',
  login: '/login',
  success: '/camon',
};
export default routes;
